export interface RoutesI {
  path: string;
  breadcrumb: string;
}

export const routes: RoutesI[] = [
  { path: "/", breadcrumb: "ГЛАВНАЯ" },
  { path: "/policy", breadcrumb: "ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ" },
  { path: "/about/blog", breadcrumb: "БЛОГ" },
  { path: "/about/blog/post", breadcrumb: "ПОСТЫ" },
  { path: "/ratings", breadcrumb: "ОТЗЫВЫ" },
  { path: "/about", breadcrumb: "О НАС" },
  { path: "/about/company", breadcrumb: "О КОМПАНИИ" },
  { path: "/services", breadcrumb: "УСЛУГИ" },
  { path: "/services/talkitout", breadcrumb: "ВЫГОВОРИТСЯ" },
  { path: "/services/careerconsulting", breadcrumb: "КАРЬЕРНАЯ КОНСУЛЬТАЦИЯ" },
  { path: "/services/cvready", breadcrumb: "РЕЗЮМЕ «ПОД КЛЮЧ»" },
  {
    path: "/services/supportduringthejobsearchsupport",
    breadcrumb: "СОПРОВОЖДЕНИЕ ПОИСКА РАБОТЫ",
  },
  {
    path: "/services/supportduringtheprobationaryperiod",
    breadcrumb: "СОПРОВОЖДЕНИЕ ИСПЫТАТЕЛЬНОГО СРОКА",
  },
  {
    path: "/services/recruitmentofITspecialists",
    breadcrumb: "ПОДБОР IT СПЕЦИАЛИСТОВ",
  },
  {
    path: "/services/trainingofITrecruiters",
    breadcrumb: "ОБУЧЕНИЕ ПРОФЕССИИ IT РЕКРУТЕР",
  },
  {
    path: "/services/vs",
    breadcrumb: "ПОДПИСКА НА ВЕДЕНИЕ ВАКАНСИЙ",
  },
];